'use strict';

exports.__esModule = true;

var _parseFloat = require('babel-runtime/core-js/number/parse-float');

var _parseFloat2 = _interopRequireDefault(_parseFloat);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _healthCheckPackages = require('../../src/styles/health-check-packages.scss');

var _healthCheckPackages2 = _interopRequireDefault(_healthCheckPackages);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import messages from '../lang/default-messages';

// import { FormattedMessage } from 'react-intl';

// import styles from '../../src/styles/style.scss';
var DECIMAL_PLACES = 2;

/**
 * Returns React elements with a title and a list of features.
 * @param {string} title The features title: "Included" or "Excluded".
 * @param {!Array<string>} features The included/excluded features.
 * @return {!Object<symbol>} React elements with a title and list of features.
 */
var getFeatures = function getFeatures(title, features) {
	var items = (features || []).map(function (feature, i) {
		return _react2.default.createElement(
			'li',
			{ key: i },
			feature
		);
	});

	return features && features.length && _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'div',
			{ className: _healthCheckPackages2.default.title },
			title
		),
		_react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'ul',
				null,
				items
			)
		)
	) || null;
};

/**
 * Returns the formatted price. Prices with decimal places will be formatted to
 * be displayed with two decimal places, adding trailing zeros if required.
 * @param {string} price The price.
 * @return {string} The formatted price.
 */
var formatPrice = function formatPrice(price) {
	return (0, _parseFloat2.default)(price).toFixed(DECIMAL_PLACES).replace(/\.00/, '');
};

/**
 * Returns a React element with the active card.
 * @param {!Object} packageItem The health check package.
 * @param {!Object} args Contains the card and health check package properties:
 *     - zIndex: The z-index to use in the card.
 *     - onClick: The on-click callback function.
 *     - key: The key for the element (used as part or React's render cycle).
 * @return {!Object<symbol>} A React element with the active card.
 */
var getActiveCard = function getActiveCard(packageItem, args) {
	return _react2.default.createElement(
		'div',
		{ className: _healthCheckPackages2.default.card + ' ' + _healthCheckPackages2.default.packageContainer,
			style: { zIndex: args.zIndex },
			key: args.key },
		_react2.default.createElement(
			'div',
			{ className: _healthCheckPackages2.default.header },
			_react2.default.createElement(
				'span',
				{ className: _healthCheckPackages2.default.name },
				packageItem.package_name
			),
			packageItem.price && packageItem.price.length > 0 && packageItem.price[0].length > 0 && _react2.default.createElement(
				'span',
				{ className: _healthCheckPackages2.default.price },
				'\xA3' + formatPrice(packageItem.price[0]) + (packageItem.price[1] > 0 ? '-' : ''),
				packageItem.price[1].length > 0 ? '\xA3' + formatPrice(packageItem.price[1]) : ''
			) || _react2.default.createElement(
				'span',
				{ className: _healthCheckPackages2.default.price },
				'Price unavailable'
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _healthCheckPackages2.default.body },
			_react2.default.createElement(
				'div',
				{ className: _healthCheckPackages2.default.features },
				getFeatures('Included', packageItem.included_features),
				getFeatures('Excluded', packageItem.excluded_features)
			),
			_react2.default.createElement(
				'button',
				{ onClick: function onClick() {
						return args.onClick(packageItem);
					} },
				'Enquire Now!'
			)
		)
	);
};

/**
 * Returns a React element with a card positioned in the background.
 * @param {!Object} packageItem The health check package.
 * @param {!Object} args Contains the card and health check package properties:
 *     - className: The class name to use in the card.
 *     - zIndex: The z-index to use in the card.
 *     - onClick: The on-click callback function.
 *     - key: The key for the element (used as part or React's render cycle).
 * @return {!Object<symbol>} A React element with a card positioned in the
 *     background.
 */
var getBackgroundCard = function getBackgroundCard(packageItem, args) {
	return _react2.default.createElement(
		'div',
		{ className: _healthCheckPackages2.default.card + ' ' + _healthCheckPackages2.default.backgroundCard + ' ' + args.className,
			style: { zIndex: args.zIndex },
			onClick: function onClick() {
				return args.onClick(packageItem.id);
			},
			key: args.key },
		_react2.default.createElement(
			'span',
			{ className: _healthCheckPackages2.default.name },
			packageItem.package_name
		),
		packageItem.price && packageItem.price.length > 0 && packageItem.price[0] > 0 && _react2.default.createElement(
			'span',
			{ className: _healthCheckPackages2.default.price },
			'From \xA3',
			packageItem.price[0]
		) || _react2.default.createElement(
			'span',
			{ className: _healthCheckPackages2.default.price },
			'Price unavailable'
		)
	);
};

/**
 * Returns an array of React elements with cards for each health check package.
 * @param {!Object} props The props provided to the React component.
 * @return {!Array<symbol>} React elements with cards for each health check
 *     package.
 */
var getPackageCards = function getPackageCards(props) {
	// Index of the active package. Defaults to the first available package.
	var activeIndex = props.packages.findIndex(function (item) {
		return item.id === (props.activePackageId || props.packages.length > 0 && props.packages[0].id);
	});
	var cards = [];

	props.packages.forEach(function (currentPackage, index) {
		if (index !== activeIndex) {
			cards.push(getBackgroundCard(currentPackage, {
				key: 'package' + index,
				className: _healthCheckPackages2.default[index < activeIndex ? 'topCard' : 'bottomCard'],
				zIndex: index < activeIndex ? index : props.packages.length - index - 1,
				onClick: props.onPackageSelected
			}));
		} else {
			cards.push(getActiveCard(currentPackage, {
				key: 'package' + index,
				zIndex: props.packages.length - 1,
				onClick: props.onBookButtonClicked
			}));
		}
	});

	return cards;
};

var HealthCheckPackages = function HealthCheckPackages(props) {
	return props.packages && props.packages.length && _react2.default.createElement(
		'div',
		{ className: _healthCheckPackages2.default.cardsContainer + ' ' + props.className },
		getPackageCards(props)
	) || null;
};

HealthCheckPackages.propTypes = {
	packages: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
	activePackageId: require('react').PropTypes.number,
	onPackageSelected: require('react').PropTypes.func,
	onBookButtonClicked: require('react').PropTypes.func.isRequired,
	className: require('react').PropTypes.string
};
HealthCheckPackages.displayName = 'HealthCheckPackages';

HealthCheckPackages.defaultProps = {
	packages: []
};

exports.default = HealthCheckPackages;


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/health-check-packages.js